import { useTypedDispatch, useTypedSelector } from '../../../../../../redux/hooks';
import sprite from '../../../../../../assets/images/sprite.svg';
import { StyledLink } from '../../AssortmentList/ListItem/ListItem.styled';
import {
  ArrowButton,
  Wrap,
  BackButton,
  TitleText,
} from '../../MobileAssortment/MobileAssortment.styled';
import { BatteriesList } from '../BatteriesList/BatteriesList';
import { MobileDrawer } from 'components/Shared/MobileDrawer';
import {
  selectMenu,
  selectThirdMenu,
} from '../../../../../../redux/menu/menuSelectors';
import {
  setMenuOpen,
  setSubMenuOpen,
  setThirdMenuOpen,
} from '../../../../../../redux/menu/menuSlice';
import { MouseEvent } from 'react';

export const MobileBatteries = () => {
  const dispatch = useTypedDispatch();
  const isMenuOpen = useTypedSelector(selectMenu);
  const isThirdMenuOpen = useTypedSelector(selectThirdMenu);

  // Plain (non-curried) so BatteriesList's `handleClick(newOpen)` — invoked
  // on subcategory link clicks (18650, 21700, …) — actually runs these
  // dispatches instead of just producing an unused function. The ArrowButton
  // below still needs to stop the click from bubbling up to the parent
  // drawer's own close-on-click handler, so it stops propagation itself.
  const openAll = (newOpen: boolean) => {
    if (isMenuOpen) {
      dispatch(setMenuOpen(newOpen));
      dispatch(setSubMenuOpen(newOpen));
      dispatch(setThirdMenuOpen(newOpen));
    }
  };

  const handleArrowClick = (e: MouseEvent<HTMLElement>) => {
    openAll(true);
    e.stopPropagation();
  };

  const toggleDrawer = () => {
    dispatch(setThirdMenuOpen(!isThirdMenuOpen));
  };

  return (
    <>
      <StyledLink to="/batteries">Елементи</StyledLink>

      <ArrowButton type="button" onClick={handleArrowClick}>
        <svg>
          <use href={`${sprite}#arrow-left`}></use>
        </svg>
      </ArrowButton>

      <MobileDrawer
        isOpen={isThirdMenuOpen}
        toggle={toggleDrawer}
        anchor="left"
      >
        <Wrap>
          <BackButton type="button" onClick={toggleDrawer}>
            <svg>
              <use href={`${sprite}#arrow-left`}></use>
            </svg>
          </BackButton>
          <TitleText>Елементи</TitleText>
        </Wrap>
        <BatteriesList handleClick={openAll} />
      </MobileDrawer>
    </>
  );
};
